module.exports = __webpack_public_path__ + "img/linkedin.e2d567ea.svg";